import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { NgcCookieConsentService, NgcStatusChangeEvent } from 'ngx-cookieconsent';
import { AnalyticsService } from './analytics.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {
  private consentChanged = new Subject<boolean>();
  consentChanged$ = this.consentChanged.asObservable();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private cookieService: CookieService,
    private cookieConsentService: NgcCookieConsentService,
    private analyticsService: AnalyticsService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      // Subscribe to status changes
      this.cookieConsentService.statusChange$.subscribe(
        (event: NgcStatusChangeEvent) => this.handleCookieConsentChange(event)
      );
    }
  }

  initialize(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    console.log('CookieConsentService: initialize() aufgerufen');

    // Check for existing consent
    const hasConsent = this.hasAnalyticsConsent();
    console.log('CookieConsentService: hasAnalyticsConsent =', hasConsent);

    if (hasConsent) {
      // If already has consent, load GA4
      console.log('CookieConsentService: Einwilligung vorhanden, GA4 laden...');
      this.analyticsService.loadGa4();
    }
  }

  hasAnalyticsConsent(): boolean {
    const cookieValue = this.cookieService.get('cookieconsent_status');
    console.log('CookieConsentService: Cookie-Wert für "cookieconsent_status":', cookieValue);
    return cookieValue === 'allow';
  }

  private handleCookieConsentChange(event: NgcStatusChangeEvent): void {
    console.log('CookieConsentService: Cookie-Consent-Status geändert:', event.status);

    const hasConsent = event.status === 'allow';
    
    if (hasConsent) {
      console.log('CookieConsentService: Einwilligung erteilt, GA4 laden...');
      this.analyticsService.loadGa4();
    } else {
      console.log('CookieConsentService: Einwilligung verweigert oder zurückgezogen, GA4 entfernen...');
      this.analyticsService.removeGa4();
    }

    this.consentChanged.next(hasConsent);
  }
}